import React, { useState } from "react";
import { Button, TextAreaField } from "../../../helpers";


const RejectVendorPaymentModal = (props) =>{
    const { handleRejectVendorPayment } = props
    const [rejectedRemarks, setRejectedRemarks] = useState("")

    const handleReject = () => {
        handleRejectVendorPayment(rejectedRemarks)
    }

    const handleRejectedRemarks = (event) => {
        setRejectedRemarks(event.target.value)
    }

    return(
        <div className="vp-reject-modal flex flex-column">
            <div className="flex flex-column text-area">
                <TextAreaField name="remarks" labelText="Enter Remarks" rows={2} value={rejectedRemarks} onChange={handleRejectedRemarks} />
            </div>
            <div className="flex flex-row justify-content-end mt-3">
                <Button icon="" className="small-btn" label="Reject" onClick={handleReject} />
            </div>
        </div>
    )
}

export default RejectVendorPaymentModal